/** @module csi/widget/DropDownMenuPlugin */
define([
	"dojo/_base/declare",
	"dijit/form/DropDownButton",
	"csi/_base/underscore",
	"./_Plugin",
	"./util",
	"dojo/text!./resources/DropDownButton.html"
], function(declare,DropDownButton,_,_Plugin, util,template) {

	return declare([DropDownButton, _Plugin], {
		templateString: template,
		/**
		 * highlight menu item for current style value
		 */
		openDropDown: function() {
			this.inherited(arguments);

			// reset last selection.
			this.resetSelection();
			var shapes = this.editor.shapeSelections;
			var value;
			if (this.editor.canvasApp.selection.isTextDrawMode()) {
				value = this.decode(util.resolve(this.propertyKey, this.editor.canvasApp.selection.getTextShapeDefaults()));
			} else {
				value = this.decode(util.resolve(this.propertyKey, this.editor.canvasApp.selection.getShapeDefaults()));
			}
			if(shapes && shapes.length) {
				value = this.decode(this.editor.canvasApp.selection.getCommonValue(shapes, this.propertyKey));
			}
			_.each(this.dropDown.getChildren(),function(item){
				if(item.get("value") == value) {
					this.onSelectDropDown(item);
				}
			},this);

		},

		/**
		 * extension point to override
		 * @param {Object} shape
		 * @returns {String} attribute value.
		 */
		getShapeAttrValue: function(shape) {
			return util.resolve(shape, this.propertyKey);
		},

		/**
		 * call onSelectDropDown
		 * @param {Event} e
		 * @param {Object} item
		 */
		onClickDropDown: function(e, item) {
			this.inherited(arguments);
			this.onSelectDropDown(item);
		},

		/**
		 * Sets the selected style on item and remove the selected style from all other items
		 * @param {Object} item
		 */
		onSelectDropDown: function(item) {
			var jItem = $(item.domNode);
			jItem.siblings().removeClass('dijitMenuItemSelected csi-svg-menu-item-selected');
			jItem.addClass('dijitMenuItemSelected csi-svg-menu-item-selected');
		},

		/**
		 * Reset last selection. If multiple shapes support different styles we want to show no selection.
		 */
		resetSelection: function() {
			_.each(this.dropDown.getChildren(),function(item){
				var jItem = $(item.domNode);
				jItem.removeClass('dijitMenuItemSelected csi-svg-menu-item-selected');
			},this);
		}
	});
});
